import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import {
  FormLabel,
  styled,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import DatePicker from '@material-ui/lab/DatePicker';
import EditIcon from '@material-ui/icons/Edit';
import InsertCommentIcon from '@material-ui/icons/InsertComment';

import { useAPI } from '../../utils/api';
import { makeStyles } from '@material-ui/styles';
import Selector from '../../components/selector';
import { useAuth } from '../../utils/auth';
import { MODE } from '../../utils/mode';
import { useDialog } from '../../utils/dialog';
import { getHrefUrl } from '../../utils/printOrderConvert';

const useStyles = makeStyles({
  root: {
    '&:last-of-type td': {
      borderBottom: 'none',
    },
  },
});

const MemberItemContainer = styled(Grid)({
  textAlign: 'center',
  borderLeft: '1px solid',
});

const goStatus = (mystr) => {
  const url = `/#/record/status/${mystr.string}`;
  window.open(url, '_blank');
};

const MemberItemGrid = styled(Grid)({
  padding: 6,
  borderBottom: '1px solid',
  borderRight: '1px solid',
  display: 'block',
  alignItems: 'center',
  justifyContent: 'center',
  overflowWrap: 'anywhere',
});

const ParsedCell = ({ text, isStatus }) => {
  const data = text ? text.split('\n').map((s) => s.trim()) : [];
  return (
    <>
      {data.map((string, index) =>
        isStatus && index === 0 ? (
          <Box key={`${string}-${index}`} display="block">
            <Link
              onClick={() => goStatus({ string })}
              href="javascript:void(0)"
            >
              {string}
            </Link>
          </Box>
        ) : (
          <Box key={`${string}-${index}`}>{string}</Box>
        )
      )}
    </>
  );
};

ParsedCell.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isStatus: PropTypes.bool,
};

ParsedCell.defaultProps = {
  text: '',
  isStatus: false,
};

const createData = ({
  orderID,
  isPrinted,
  isCommented,
  orderStatus,
  memberInfo,
  receiver,
  sender,
  orderInfo,
  rating,
  isShowStay,
  isShowReassign,
}) => {
  const orderEditUrl = `/#/record/${MODE.EDIT}/${
    orderID || '210701152410770371'
  }`;
  const commentUrl = `/#/record/comment/${isCommented ? MODE.EDIT : MODE.NEW}/${
    orderID || '210701152410770371'
  }`;

  const printList = [];
  printList.push(orderID);
  const printOrderUrl = getHrefUrl(JSON.stringify(printList));

  return {
    orderID,
    isPrinted,
    isCommented,
    orderStatus,
    memberInfo,
    receiver,
    sender,
    orderInfo,
    rating,
    orderEditUrl,
    commentUrl,
    printOrderUrl,
    isShowReassign,
    isShowStay,
  };
};

const columns = [
  { id: 'readyToPrint', label: '列印' },
  { id: 'isPrinted', label: '列印狀態' },
  { id: 'orderStatus', label: '案件狀態' },
  { id: 'memberInfo', label: '會員資訊' },
  {
    id: 'sender',
    label: '取件方',
  },
  {
    id: 'receiver',
    label: '送件方',
  },
  {
    id: 'orderInfo',
    label: '案件資訊',
  },
  {
    id: 'rating',
    label: '評價分數',
  },
  {
    id: 'function',
    label: '功能',
    minWidth: '300px',
  },
];

const EventRecordPage = () => {
  const classes = useStyles();
  const api = useAPI();
  const auth = useAuth();
  const dialog = useDialog();

  const listForm = useRef();

  const [orderStatusOptions, setOrderStatusOptions] = useState([]);
  const [printStatusOptions, setPrintStatusOptions] = useState([]);
  const [shouldPageUpdated, setShouldPageUpdated] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);

  const [orders, setOrders] = useState([]);
  const [isUnmounted, setIsUnmounted] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [filterData, setFilterData] = useState({});

  const [paymentMethod, setPaymentMethod] = useState('');
  const [createTimeValue, setCreateTimeValue] = useState(null);
  const [pickupTimeValue, setPickupTimeValue] = useState(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const deleteOrder = (orderID) => {
    const yes = confirm('確定刪除嗎？');
    if (yes) {
      api
        .deleteOrder({ orderID })
        .then(() => {
          dialog.openAlert({ message: '刪除成功' });
          if (isFilter) {
            api
              .getOrdersByFilter(filterData)
              .then((orderData) => {
                updateOrderData(orderData);
                setShouldPageUpdated(true);
              })
              .catch(() => {});
          } else {
            const memberID = auth && auth.user ? auth.user.memberID : -1;
            api
              .getDefaultOrdersByMemberID({ memberID })
              .then((orderData) => {
                updateOrderData(orderData);
                setShouldPageUpdated(true);
              })
              .catch(() => {});
          }
        })
        .catch(() => {});
    }
  };

  const saveInDepot = (orderID) => {
    const yes = confirm('確定留庫？');
    if (yes) {
      api
        .saveInDepot({ orderID })
        .then(() => {
          dialog.openAlert({ message: '成功' });
          if (isFilter) {
            api
              .getOrdersByFilter(filterData)
              .then((orderData) => {
                updateOrderData(orderData);
                setShouldPageUpdated(true);
              })
              .catch(() => {});
          } else {
            const memberID = auth && auth.user ? auth.user.memberID : -1;
            api
              .getDefaultOrdersByMemberID({ memberID })
              .then((orderData) => {
                updateOrderData(orderData);
                setShouldPageUpdated(true);
              })
              .catch(() => {});
          }
        })
        .catch(() => {});
    }
  };

  const reassignOrder = (orderID) => {
    const yes = confirm('確定重派？');
    if (yes) {
      api
        .reassignOrder({ orderID })
        .then(() => {
          dialog.openAlert({ message: '成功' });
          if (isFilter) {
            api
              .getOrdersByFilter(filterData)
              .then((orderData) => {
                updateOrderData(orderData);
                setShouldPageUpdated(true);
              })
              .catch(() => {});
          } else {
            const memberID = auth && auth.user ? auth.user.memberID : -1;
            api
              .getDefaultOrdersByMemberID({ memberID })
              .then((orderData) => {
                updateOrderData(orderData);
                setShouldPageUpdated(true);
              })
              .catch(() => {});
          }
        })
        .catch(() => {});
    }
  };

  const updateOrderData = (orderData) => {
    // if (!isUnmounted) {
    const rows = [];
    orderData.map((item) => {
      rows.push(
        createData({
          orderID: item.orderID,
          isPrinted: item.isPrinted,
          isCommented: item.isCommented,
          orderStatus: item.orderStatus,
          memberInfo: item.memberInfo,
          receiver: item.receiver,
          sender: item.sender,
          orderInfo: item.orderInfo,
          rating: item.rating,
          isShowReassign: item.isShowReassign,
          isShowStay: item.isShowStay,
        })
      );
    });

    setOrders(rows);
    // }
  };

  const searchOrders = (event) => {
    event.preventDefault();
    setIsFilter(true);
    const form = event.target;
    const formData = new FormData(form);

    if (
      formData.get('createTime') == null ||
      formData.get('createTime') === ''
    ) {
      dialog.openAlert({ message: '進件時間為必填項目' });
      return;
    }

    const data = {
      orderID: formData.get('orderID'), // 案件編號
      orderStatus: formData.get('orderStatus'), // 案件狀態
      accountCode:
        auth.user.isAdmin === true
          ? formData.get('accountCode')
          : auth.user.accountCode,
      memberID: auth.user.isAdmin === true ? -1 : auth.user.memberID, // 客戶編號
      contactName: formData.get('contactName'), // 取件方聯絡人
      address: formData.get('address'), // 客戶地址
      phone: formData.get('phone'), // 客戶電話/分機
      createTime: formData.get('createTime'), // 進件時間
      pickupTime: formData.get('pickupDatetime'), // 取件時間
      printStatus: formData.get('printStatus'), // 列印狀態
      paymentMethod, // 付款方式
    };
    setFilterData(data);
    api
      .getOrdersByFilter(data)
      .then((orderData) => {
        updateOrderData(orderData);
        setShouldPageUpdated(true);
      })
      .catch(() => {});
  };

  useEffect(() => {
    return () => {
      setShouldPageUpdated(false);
    };
  }, [shouldPageUpdated]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const printOrder = (orderID) => {
    const printList = [];
    printList.push(orderID);
    api
      .updatePrintStatus(printList)
      .then(() => {
        const url = getHrefUrl(JSON.stringify(printList));
        window.open(url, '_blank');
      })
      .catch(() => {});
  };

  const printAllSelected = () => {
    if (!listForm || !listForm.current || !orders || orders.length === 0)
      return;
    const form = listForm.current;
    const formData = new FormData(form);

    const printList = [];
    for (const [index, order] of orders.entries()) {
      if (formData.get(`readyToPrint-${index}`) === 'true') {
        printList.push(order.orderID);
      }
    }

    api
      .updatePrintStatus(printList)
      .then(() => {
        const url = getHrefUrl(JSON.stringify(printList));
        window.open(url, '_blank');
      })
      .catch(() => {});
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);

  const handleSelectAll = () => {
    setIsCheckAll(!isCheckAll);
    const eachList = [];
    for (const [index] of orders.entries()) {
      eachList.push(`readyToPrint-${index}`, `readyToPrint-s-${index}`);
    }
    setIsCheck(eachList);
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleClick = (even) => {
    const { id, checked } = even.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };

  useEffect(() => {
    const memberID = auth && auth.user ? auth.user.memberID : -1;

    api
      .getOrderStatusDropDownList()
      .then((list) => {
        if (!isUnmounted) {
          setOrderStatusOptions(list);
        }
      })
      .catch(() => {});

    api
      .getPrintStatus()
      .then((list) => {
        if (!isUnmounted) {
          setPrintStatusOptions(list);
        }
      })
      .catch(() => {});

    api
      .getDropdownPaymentMethods()
      .then((list) => {
        if (!isUnmounted) {
          setPaymentMethods(list);
        }
      })
      .catch(() => {});
    setIsFilter(false);

    api
      .getDefaultOrdersByMemberID({ memberID })
      .then((orderData) => {
        updateOrderData(orderData);
      })
      .catch(() => {});

    const dateNow = new Date();
    dateNow.setDate(dateNow.getDate() - 7);
    setCreateTimeValue(dateNow);

    return () => {
      setIsUnmounted(true);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Paper
        elevation={4}
        sx={{
          paddingTop: { xs: 1, md: 2 },
          paddingBottom: { xs: 2, md: 4 },
          marginBottom: 4,
          maxWidth: '900px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <Container>
          <Typography variant="h6" gutterBottom display="inline" mr="2px">
            查詢條件
          </Typography>
          <Typography
            variant="body2"
            gutterBottom
            display="inline"
            color="#aaa"
          >
            (預設為7日內產生的訂單)
          </Typography>
          <Box component="form" noValidate onSubmit={searchOrders}>
            <Grid container spacing={{ xs: 1, md: 2 }}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  required
                  id="orderID"
                  name="orderID"
                  label="案件編號"
                  fullWidth
                  variant="standard"
                  size="small"
                  autoComplete="none"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  required
                  id="accountCode"
                  name="accountCode"
                  label="客戶編號"
                  fullWidth
                  variant={auth.user.isAdmin ? 'standard' : 'filled'}
                  size="small"
                  autoComplete="none"
                  disabled={auth.user.isAdmin ? false : true}
                  defaultValue={auth.user.isAdmin ? '' : auth.user.accountCode}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Selector
                  required
                  id="orderStatus"
                  name="orderStatus"
                  label="案件狀態"
                  fullWidth
                  variant="standard"
                  size="small"
                  autoComplete="none"
                  placeHolder="案件狀態"
                  options={orderStatusOptions}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4}>
                <TextField
                  required
                  id="memberID"
                  name="memberID"
                  label="客戶編號"
                  fullWidth
                  variant="standard"
                  size="small"
                  autoComplete="none"
                />
              </Grid> */}

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  required
                  id="contactName"
                  name="contactName"
                  label="取件方聯絡人"
                  fullWidth
                  variant="standard"
                  size="small"
                  autoComplete="none"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  required
                  id="address"
                  name="address"
                  label="客戶地址"
                  fullWidth
                  variant="standard"
                  size="small"
                  autoComplete="none"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  required
                  id="phone"
                  name="phone"
                  label="客戶電話/分機"
                  fullWidth
                  variant="standard"
                  size="small"
                  autoComplete="none"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <DatePicker
                  label="進件時間"
                  value={createTimeValue}
                  onChange={(newValue) => {
                    setCreateTimeValue(newValue);
                  }}
                  mask="____-__-__"
                  inputFormat={'yyyy-MM-dd'}
                  clearable={true}
                  clearText="清除"
                  cancelText="取消"
                  okText="確定"
                  renderInput={(parameters) => (
                    <TextField
                      id="createTime"
                      name="createTime"
                      label="進件時間"
                      fullWidth
                      variant="standard"
                      size="small"
                      autoComplete="none"
                      {...parameters}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <DatePicker
                  label="取件時間"
                  value={pickupTimeValue}
                  onChange={(newValue) => {
                    setPickupTimeValue(newValue);
                  }}
                  mask="____-__-__"
                  inputFormat={'yyyy-MM-dd'}
                  clearable={true}
                  clearText="清除"
                  cancelText="取消"
                  okText="確定"
                  renderInput={(parameters) => (
                    <TextField
                      required
                      id="pickupDatetime"
                      name="pickupDatetime"
                      label="取件時間"
                      fullWidth
                      variant="standard"
                      size="small"
                      autoComplete="none"
                      {...parameters}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Selector
                  required
                  id="printStatus"
                  name="printStatus"
                  label="列印狀態"
                  fullWidth
                  variant="standard"
                  size="small"
                  autoComplete="none"
                  placeHolder="列印狀態"
                  defaultValue="99"
                  options={printStatusOptions}
                />
              </Grid>

              <Grid container item xs={12}>
                <Grid item xs={12} marginTop={1}>
                  <FormLabel>付款方式</FormLabel>
                </Grid>

                <Grid item xs={12}>
                  <RadioGroup
                    row
                    aria-label="paymentMethod"
                    name="paymentMethod"
                    value={paymentMethod}
                    onChange={(event) => setPaymentMethod(event.target.value)}
                  >
                    {paymentMethods &&
                      paymentMethods.map((option) => (
                        <FormControlLabel
                          key={option.value}
                          value={option.value}
                          control={<Radio />}
                          label={option.text}
                          sx={{ paddingTop: 1 }}
                        />
                      ))}
                  </RadioGroup>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={3}
                sx={{ margin: 'auto', width: '100%', justifyContent: 'center' }}
              >
                <Grid item xs={10} sm={4} sx={{ maxWidth: '200px' }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                  >
                    搜尋
                  </Button>
                </Grid>
                <Grid item xs={10} sm={4} sx={{ maxWidth: '200px' }}>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    color="warning"
                    onClick={() => printAllSelected()}
                    sx={{ color: 'white' }}
                  >
                    列印勾選的托運單
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Paper>

      <Button variant="contained" onClick={handleSelectAll}>
        全選
      </Button>
      <Typography variant="body2" marginBottom={1} textAlign="center">
        共找到 {orders ? orders.length : 0} 筆資料
      </Typography>

      <Box ref={listForm} component="form">
        <Paper
          sx={{ width: '100%', overflow: 'hidden', padding: 1 }}
          elevation={5}
        >
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow
                  sx={{
                    display: { xs: 'none', sm: 'table-row' },
                  }}
                >
                  {orders && columns
                    ? columns.map((column, index) => (
                        <TableCell
                          key={`${column.id}-${index}`}
                          align={column.align || 'center'}
                          sx={{
                            minWidth: column.minWidth || 'none',
                            padding: 1,
                            maxWidth: '100%',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))
                    : undefined}
                </TableRow>
              </TableHead>

              <TableBody>
                {orders && !shouldPageUpdated
                  ? orders
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, rowIndex) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={`${row.memberID}-${rowIndex}`}
                            className={classes.root}
                          >
                            {orders && columns
                              ? columns.map((column, columnIndex) => {
                                  return (
                                    <TableCell
                                      key={`${column.id}-${columnIndex}`}
                                      align={column.align || 'center'}
                                      sx={{
                                        display: {
                                          xs: 'none',
                                          sm: 'table-cell',
                                        },
                                        padding: 1,
                                        minHeight: '0',
                                        maxWidth: '100%',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {column.id === 'function' ? (
                                        <Grid container spacing={1}>
                                          <Grid item xs={3}>
                                            <Link
                                              underline="none"
                                              href={row.commentUrl}
                                              sx={{ textDecoration: 'none' }}
                                            >
                                              <Button
                                                type="button"
                                                fullWidth
                                                variant="contained"
                                                color={
                                                  row.isCommented
                                                    ? 'gray'
                                                    : 'warning'
                                                }
                                                // startIcon={
                                                //   <InsertCommentIcon />
                                                // }
                                                sx={{ color: 'white' }}
                                              >
                                                {row.isCommented
                                                  ? '已評價'
                                                  : '我想評價'}
                                              </Button>
                                            </Link>
                                          </Grid>
                                          {auth.user.isAdmin ? (
                                            <Grid item xs={3}>
                                              <Link
                                                underline="none"
                                                href={row.orderEditUrl}
                                                sx={{ textDecoration: 'none' }}
                                              >
                                                <Button
                                                  type="button"
                                                  fullWidth
                                                  variant="contained"
                                                  color="primary"
                                                  // startIcon={<EditIcon />}
                                                  sx={{ color: 'white' }}
                                                >
                                                  修改
                                                </Button>
                                              </Link>
                                            </Grid>
                                          ) : undefined}
                                          <Grid item xs={3}>
                                            {/* <Link
                                              underline="none"
                                              href={row.printOrderUrl}
                                              sx={{ textDecoration: 'none' }}
                                            > */}
                                            <Button
                                              type="button"
                                              fullWidth
                                              variant="contained"
                                              color="info"
                                              onClick={() => {
                                                printOrder(row.orderID);
                                              }}
                                              sx={{ color: 'white' }}
                                            >
                                              列印
                                            </Button>
                                            {/* </Link> */}
                                          </Grid>
                                          {auth.user.isAdmin ? (
                                            <Grid item xs={3}>
                                              <Button
                                                type="button"
                                                fullWidth
                                                variant="contained"
                                                color={'gray'}
                                                onClick={() =>
                                                  deleteOrder(row.orderID)
                                                }
                                                // startIcon={<EditIcon />}
                                                sx={{ color: 'white' }}
                                              >
                                                刪除
                                              </Button>
                                            </Grid>
                                          ) : undefined}
                                          {auth.user.isAdmin &&
                                          row.isShowReassign === true ? (
                                            <Grid item xs={3}>
                                              <Button
                                                type="button"
                                                fullWidth
                                                variant="contained"
                                                color={'secondary'}
                                                onClick={() =>
                                                  reassignOrder(row.orderID)
                                                }
                                                sx={{ color: 'white' }}
                                              >
                                                重派
                                              </Button>
                                            </Grid>
                                          ) : undefined}
                                          {auth.user.isAdmin &&
                                          row.isShowStay === true ? (
                                            <Grid item xs={3}>
                                              <Button
                                                type="button"
                                                fullWidth
                                                variant="contained"
                                                color={'success'}
                                                onClick={() =>
                                                  saveInDepot(row.orderID)
                                                }
                                                sx={{ color: 'white' }}
                                              >
                                                留庫
                                              </Button>
                                            </Grid>
                                          ) : undefined}
                                        </Grid>
                                      ) : column.id === 'rating' ? (
                                        <Typography
                                          variant="h5"
                                          fontWeight="bold"
                                        >
                                          {row[column.id]}
                                        </Typography>
                                      ) : column.id === 'readyToPrint' ? (
                                        <Checkbox
                                          id={`readyToPrint-${rowIndex}`}
                                          name={`readyToPrint-${rowIndex}`}
                                          value="true"
                                          color="primary"
                                          checked={isCheck.includes(
                                            `readyToPrint-${rowIndex}`
                                          )}
                                          onChange={handleClick}
                                        />
                                      ) : typeof row[column.id] ===
                                        'boolean' ? (
                                        column.id === 'isPrinted' ? (
                                          row[column.id] ? (
                                            '已列印'
                                          ) : (
                                            '未列印'
                                          )
                                        ) : (
                                          ''
                                        )
                                      ) : (
                                        <ParsedCell
                                          text={row[column.id]}
                                          isStatus={column.id === 'orderStatus'}
                                        />
                                      )}
                                    </TableCell>
                                  );
                                })
                              : undefined}

                            <TableCell
                              sx={{
                                display: {
                                  xs: 'block',
                                  sm: 'none',
                                  width: '100%',
                                },
                              }}
                            >
                              <MemberItemContainer
                                container
                                borderTop="1px solid"
                                fontWeight="bold"
                              >
                                <MemberItemGrid item xs={12}>
                                  列印
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer container>
                                <MemberItemGrid item xs={12}>
                                  <Checkbox
                                    id={`readyToPrint-s-${rowIndex}`}
                                    name={`readyToPrint-${rowIndex}`}
                                    value="true"
                                    color="primary"
                                    checked={isCheck.includes(
                                      `readyToPrint-s-${rowIndex}`
                                    )}
                                    onChange={handleClick}
                                  />
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer
                                container
                                borderTop="1px solid"
                                fontWeight="bold"
                              >
                                <MemberItemGrid item xs={12}>
                                  案件狀態
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer container>
                                <MemberItemGrid item xs={12}>
                                  <ParsedCell
                                    text={row.orderStatus}
                                    isStatus={true}
                                  />
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer container fontWeight="bold">
                                <MemberItemGrid item xs={12}>
                                  會員資訊
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer container>
                                <MemberItemGrid item xs={12}>
                                  <ParsedCell text={row.memberInfo} />
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer container fontWeight="bold">
                                <MemberItemGrid item xs={12}>
                                  取件方
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer container>
                                <MemberItemGrid item xs={12}>
                                  <ParsedCell text={row.sender} />
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer container fontWeight="bold">
                                <MemberItemGrid item xs={12}>
                                  送件方
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer container>
                                <MemberItemGrid item xs={12}>
                                  <ParsedCell text={row.receiver} />
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer container fontWeight="bold">
                                <MemberItemGrid item xs={12}>
                                  案件資訊
                                </MemberItemGrid>
                              </MemberItemContainer>
                              <MemberItemContainer container>
                                <MemberItemGrid item xs={12}>
                                  <ParsedCell text={row.orderInfo} />
                                </MemberItemGrid>
                              </MemberItemContainer>
                              {/* <MemberItemContainer container fontWeight="bold">
                                <MemberItemGrid item xs={12}>
                                  取件方
                                </MemberItemGrid>
                              </MemberItemContainer> */}
                              <MemberItemContainer container>
                                <Grid
                                  item
                                  container
                                  xs={12}
                                  spacing={1}
                                  padding={1}
                                  borderBottom="1px solid"
                                  borderRight="1px solid"
                                  justifyContent="center"
                                >
                                  <Grid item xs={6}>
                                    <Link
                                      underline="none"
                                      href={row.commentUrl}
                                      sx={{ textDecoration: 'none' }}
                                    >
                                      <Button
                                        type="button"
                                        fullWidth
                                        variant="contained"
                                        color={
                                          row.isCommented ? 'gray' : 'warning'
                                        }
                                        startIcon={<InsertCommentIcon />}
                                        sx={{ color: 'white' }}
                                      >
                                        {row.isCommented
                                          ? '已評價'
                                          : '我想評價'}
                                      </Button>
                                    </Link>
                                  </Grid>
                                </Grid>
                              </MemberItemContainer>
                              <MemberItemContainer container>
                                <Grid
                                  item
                                  container
                                  xs={12}
                                  spacing={1}
                                  padding={1}
                                  borderBottom="1px solid"
                                  borderRight="1px solid"
                                  justifyContent="center"
                                >
                                  {auth.user.isAdmin ? (
                                    <Grid item xs={4}>
                                      <Link
                                        underline="none"
                                        href={row.orderEditUrl}
                                        sx={{ textDecoration: 'none' }}
                                      >
                                        <Button
                                          type="button"
                                          fullWidth
                                          variant="contained"
                                          color="primary"
                                          startIcon={<EditIcon />}
                                          sx={{ color: 'white' }}
                                        >
                                          修改
                                        </Button>
                                      </Link>
                                    </Grid>
                                  ) : undefined}
                                  <Grid item xs={4}>
                                    {/* <Link
                                      underline="none"
                                      href={row.printOrderUrl}
                                      sx={{ textDecoration: 'none' }}
                                    > */}
                                    <Button
                                      type="button"
                                      fullWidth
                                      variant="contained"
                                      color="info"
                                      onClick={() => {
                                        printOrder(row.orderID);
                                      }}
                                      sx={{ color: 'white' }}
                                    >
                                      列印
                                    </Button>
                                    {/* </Link> */}
                                  </Grid>
                                  {auth.user.isAdmin ? (
                                    <Grid item xs={4}>
                                      <Link
                                        underline="none"
                                        href={row.commentUrl}
                                        sx={{ textDecoration: 'none' }}
                                      >
                                        <Button
                                          type="button"
                                          fullWidth
                                          variant="contained"
                                          color={'gray'}
                                          sx={{ color: 'gray' }}
                                        >
                                          刪除
                                        </Button>
                                      </Link>
                                    </Grid>
                                  ) : undefined}
                                  {auth.user.isAdmin &&
                                  row.isShowReassign === true ? (
                                    <Grid item xs={4}>
                                      <Button
                                        type="button"
                                        fullWidth
                                        variant="contained"
                                        color={'secondary'}
                                        sx={{ color: 'gray' }}
                                      >
                                        重派
                                      </Button>
                                    </Grid>
                                  ) : undefined}
                                  {auth.user.isAdmin &&
                                  row.isShowStay === true ? (
                                    <Grid item xs={4}>
                                      <Button
                                        type="button"
                                        fullWidth
                                        variant="contained"
                                        color={'success'}
                                        sx={{ color: 'gray' }}
                                      >
                                        留庫
                                      </Button>
                                    </Grid>
                                  ) : undefined}
                                </Grid>
                              </MemberItemContainer>
                            </TableCell>
                          </TableRow>
                        );
                      })
                  : undefined}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            labelRowsPerPage="每頁顯示"
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            component="div"
            count={orders ? orders.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
};

export default EventRecordPage;
